/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateMediaExportJobsMutationRequest, WebAppCreateMediaExportJobsMutationResponse, WebAppCreateMediaExportJobs401, WebAppCreateMediaExportJobs403 } from "../models/WebAppCreateMediaExportJobs";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppCreateMediaExportJobs } from "../axios/webAppCreateMediaExportJobs";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppCreateMediaExportJobsMutationKey = () => [{ url: '/web-app/v1/export-jobs' }] as const

export type WebAppCreateMediaExportJobsMutationKey = ReturnType<typeof webAppCreateMediaExportJobsMutationKey>

export function webAppCreateMediaExportJobsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppCreateMediaExportJobsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppCreateMediaExportJobsMutationKey()
        return mutationOptions<WebAppCreateMediaExportJobsMutationResponse, ResponseErrorConfig<WebAppCreateMediaExportJobs401 | WebAppCreateMediaExportJobs403>, {data: WebAppCreateMediaExportJobsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return webAppCreateMediaExportJobs(data, config)
          },
        })

}

/**
 * @description Adds an export media job for the current user. Returns the job (id, status, progress, etc.).
 * @summary Enqueue export job
 * {@link /web-app/v1/export-jobs}
 */
export function useWebAppCreateMediaExportJobs<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppCreateMediaExportJobsMutationResponse, ResponseErrorConfig<WebAppCreateMediaExportJobs401 | WebAppCreateMediaExportJobs403>, {data: WebAppCreateMediaExportJobsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppCreateMediaExportJobsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppCreateMediaExportJobsMutationKey()

          const baseOptions = webAppCreateMediaExportJobsMutationOptions(config) as UseMutationOptions<WebAppCreateMediaExportJobsMutationResponse, ResponseErrorConfig<WebAppCreateMediaExportJobs401 | WebAppCreateMediaExportJobs403>, {data: WebAppCreateMediaExportJobsMutationRequest}, TContext>
          

          return useMutation<WebAppCreateMediaExportJobsMutationResponse, ResponseErrorConfig<WebAppCreateMediaExportJobs401 | WebAppCreateMediaExportJobs403>, {data: WebAppCreateMediaExportJobsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppCreateMediaExportJobsMutationResponse, ResponseErrorConfig<WebAppCreateMediaExportJobs401 | WebAppCreateMediaExportJobs403>, {data: WebAppCreateMediaExportJobsMutationRequest}, TContext>
      
}